module.exports = __webpack_public_path__ + "static/media/024-woman-6.ae5b196a.svg";